export const initPricesExpand = () => {
  const pricingExpands: NodeListOf<HTMLDivElement> = document.querySelectorAll(".pricing-expand");

  pricingExpands.forEach((pricingExpand) => {
    pricingExpand.addEventListener("click", () => {
      const expandId = pricingExpand.dataset.expandId;

      if (expandId) {
        const pricingExpandableContent = document.getElementById(expandId) as HTMLDivElement;
        pricingExpandableContent.classList.toggle("d-none");
      }
    });
  });
};
